import { useId, useState } from 'react';
import { RailIcon } from './SidebarRail';

export function AdminSettingsIcon() {
  return (
    <RailIcon>
      <path d="M4 7h16M4 17h16M8 4v6M16 14v6" />
    </RailIcon>
  );
}

/** A stable group: hiding it never discards a draft, request, or audio player.
 * The page keys this component by script ID so each document starts closed. */
export default function AdminSettingsPanel({ drawer, children }: {
  drawer: boolean;
  children: React.ReactNode;
}) {
  const [expanded, setExpanded] = useState(false);
  const bodyId = useId();

  return (
    <section
      data-print-hide
      className={drawer ? 'min-w-0' : 'min-w-0 rounded-md border border-line bg-card'}
    >
      <button
        type="button"
        hidden={drawer}
        aria-expanded={expanded}
        aria-controls={bodyId}
        onClick={() => setExpanded((open) => !open)}
        className="flex h-[46px] w-full items-center gap-2.5 rounded-md px-4 text-muted hover:text-fg focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-2"
      >
        <AdminSettingsIcon />
        <span className="flex-1 text-left font-mono text-[10px] uppercase tracking-[0.12em]">
          Admin settings
        </span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden className={expanded ? 'rotate-180' : ''}>
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
      <div
        id={bodyId}
        hidden={!drawer && !expanded}
        className={`grid gap-3 [&>section]:px-4 ${drawer ? '' : 'rounded-b-md border-t border-line bg-page p-3'}`}
      >
        {children}
      </div>
    </section>
  );
}
